import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EmployeeRequest from './EmployeeRequest';
import { 
    getoffRoleEmployeesData, 
    getDataForDropdown, 
    updateStatusOffroleEmployee, 
    departmentDropdownData, 
    teamDropdownData, 
    roleDropdownData, 
    reportingManagerDropdownData, 
    citiesDropdownData, 
    zonesDropdownData, 
    assignLocationsToUser,
    areasDropdownData 
  } from 'services/redux/OffRoleEmployees/action';

const mapStateToProps = (state) => ({
    getEmployeesListing: state.offroleEmployeesReducer.getEmployeesListing,
    getDropdownDatas: state.offroleEmployeesReducer.getDropdownDatas,
    statusUpdationByBusinessHead: state.offroleEmployeesReducer.statusUpdationByBusinessHead,
    departmentDropwdownResponse: state.offroleEmployeesReducer.departmentDropwdownResponse,
    teamDropdownResponse: state.offroleEmployeesReducer.teamDropdownResponse,
    roleDropdownResponse: state.offroleEmployeesReducer.roleDropdownResponse,
    reportingManagerResponse: state.offroleEmployeesReducer.reportingManagerResponse,
    citiesDropdownResponse: state.offroleEmployeesReducer.citiesDropdownResponse,
    zonesDropdownResponse: state.offroleEmployeesReducer.zonesDropdownResponse,
    areasDropdownResponse: state.offroleEmployeesReducer.areasDropdownResponse
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getoffRoleEmployeesData,
        getDataForDropdown,
        updateStatusOffroleEmployee,
        departmentDropdownData,
        teamDropdownData,
        roleDropdownData,
        reportingManagerDropdownData,
        citiesDropdownData,
        zonesDropdownData,
        assignLocationsToUser,
        areasDropdownData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeRequest);
